import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
    content: {
        padding: theme.spacing(2),
    },
    text: {
        marginTop: theme.spacing(2),
    },
    marginLeft: {
        marginLeft: theme.spacing(2),
    },

    formTitle: {
        marginBottom: theme.spacing(2),
    },
    formFormControl: {
        marginBottom: theme.spacing(3),
    },
    tab: {
        color: '#131313 !important',
        fontWeight: 'bold',
        '& .Mui-selected': { color: '#137DC5 !important' },
        '& .MuiTabs-indicator': {
            backgroundColor: '#137DC5',
        },
    },
}));
